import { useNow } from '@orgus/ui';
import { useConnection } from './store.ts';
import { hubDown } from './stream.ts';

/**
 * True while the hub cannot confirm what the page shows (see `hubDown`). The shell greys the
 * page out; a page can also turn off actions that change something, since the hub could not
 * carry them out.
 */
export function useHubDown(): boolean {
  const { connection, mode, lastMessageAt } = useConnection();
  const now = useNow(5000);
  return hubDown(connection, mode, lastMessageAt, now);
}
